import { Button, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import LoginLayout from './LoginLayout';
import { useState, useRef } from 'react';
import useToggle from 'hooks/useToggle';
import Spinner from 'components/Spinner';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'redux/store';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { showToast } from 'redux/slices/Toasts';

const BottomLink = () => {
    return (
        <Row className="mt-3">
            <Col className="text-center">
                <p className="text-muted">Back to<Link to={'/login'} className="text-muted ms-1">
                    <b>Log In</b>
                </Link>
                </p>
            </Col>
        </Row>
    );
};

const ForgetPassword = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [isValidated, setValidated] = useToggle();
    const dispatch = useAppDispatch();
    const email = useAppSelector((state: RootState) => state.login.email);

    const form = useRef(null);
    const navigate = useNavigate();

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {      
        event.preventDefault();
        event.stopPropagation();
        setLoading(true);

        // @ts-ignore
        if (form.current.checkValidity() === true) {
            sendEmail();
        }
        setValidated();
    }

    function sendEmail() {
        axios.get(`/api/v1/UserAuth/ForgotPassword`, {
            params: { email: email },
            headers: { 'Content-Encoding': 'gzip' } 
        }).then((result) => {
            if (result.data.data === true) {
                console.log(result.data);
                navigate('/confirm');
            } else {
                dispatch(showToast({ value: [result.data.error] }))
                setLoading(false);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    function handleChange(option: any, optionValue: any) {
		dispatch({
			type: 'loginSlice/updateField',
			payload: { key: option, value: optionValue }
		});
	}

    return (
        <LoginLayout bottomLinks={<BottomLink />}>
            <div className="text-center m-auto">
                <h4 className="text-dark-50 text-center mt-0 font-weight-bold">Reset Password</h4>
                <p className="text-muted mb-4">Enter your email address and we'll send you an email with instructions to reset your password</p>
            </div>
            <Form ref={form} noValidate autoComplete="off" validated={isValidated} onSubmit={(e) => handleSubmit(e)}>
                <div>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="email">Email</Form.Label>
                        <Form.Control
                            required
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => handleChange("email", e.target.value)}
                            style={{ minHeight:'38px' }}
                        />
                        <Form.Control.Feedback type="invalid">Please enter a valid email.</Form.Control.Feedback>
                    </Form.Group>
                    <div className="mb-3 mb-0 text-center">
                        <Button variant="primary" className="btn" type="submit" disabled={loading}>
                            {loading ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
                            {loading ? <>Sending...</> : <>Send</>}
                        </Button>
                    </div>
                </div>
            </Form>
        </LoginLayout>
    );
};

export default ForgetPassword;
